export const EXTRA_DIMENSIONS = Symbol('Extra Dimensions');
export const GROUP_HASH = Symbol('Group Hash');
